import React, { useCallback, useEffect, useState } from 'react';
import { ROOT_URL, ENDPOINT_LOGIN, LOCALHOST } from 'constants/constants';
import { useLoginContext } from '../providers/loginContext';

type AuthProps = {
  children: React.ReactNode;
};

let isLocal: boolean = false;

export const Auth = (props: AuthProps) => {
  const loginContext = useLoginContext();

  if (window.location.origin === LOCALHOST) isLocal = true;

  const [inputWord, setInput] = useState('');
  // トークン取得処理が完了したかを判定
  const [hasRequestedGetToken, setHasRequestedGetToken] = useState(false);
  // ログアウト実行フラグ、trueの場合にログイン処理を行わない
  const [isLogout, setIsLogout] = useState(false);

  // ログイン処理
  const login = useCallback(() => {
    // 認証URLに遷移
    window.location.assign(`${ENDPOINT_LOGIN}?url=${window.location.href}`);
  }, []);

  function input(event: any) {
    setInput(event.target.value);
  }

  // ヘッダーオプション
  const getToken = useCallback(() => {
    return loginContext.token;
  }, [loginContext]);
  // ヘッダーオプション
  const updateToken = useCallback(() => {
    return loginContext.token;
  }, [loginContext]);
  // ヘッダーオプション
  const logout = useCallback(async () => {
    // アクセストークン Store に保存
    setIsLogout(true);
    await loginContext.logoutCaaS(false);
    return ROOT_URL;
  }, [loginContext]);

  function inputToken() {
    // アクセストークン Store に保存
    loginContext.setLocalToken(inputWord);
  }

  // 初回実行
  useEffect(() => {
    // ローカル実行かつトークン入力前またはログアウト処理実行後は処理を行わない
    if ((isLocal && !loginContext.token) || isLogout) return;
    // アクセストークン取得処理が完了後にヘッダーの表示処理を行う
    loginContext
      .fetchToken()
      .then(() => {
        setHasRequestedGetToken(true);
      })
      .catch(() => {
        // ローカルの場合、処理終了
        if (isLocal) return;

        // 未ログインの為、ログイン処理
        login();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginContext.token, isLogout]);

  // 初回実行時にはすべて実行されず、トークン取得後に実行
  useEffect(() => {
    // トークン取得処理完了前またはログアウト処理実行後は処理終了
    if (hasRequestedGetToken === false || isLogout) return;

    // トークン取得完了後
    // トークンが取得できた場合
    if (loginContext.token) {
      const options: InitOptions = {
        getToken: getToken,
        updateToken: updateToken,
        logoutAfterUri: logout,
      };
      // ヘッダー初期化処理
      window.rsi.init(options);
    }
  }, [
    hasRequestedGetToken,
    loginContext,
    isLogout,
    getToken,
    updateToken,
    logout,
    login,
  ]);

  return (
    <div>
      {isLocal ? (
        <>
          {loginContext.token === '' ? (
            <div>
              <input
                className="rsi-textbox"
                placeholder="アクセストークン"
                value={inputWord}
                onChange={input}
              ></input>
              <div className="rsi-button is-primary" onClick={inputToken}>
                ログイン
              </div>
            </div>
          ) : (
            <>{props.children}</>
          )}
        </>
      ) : (
        <>{loginContext.token === '' ? <></> : <>{props.children}</>}</>
      )}
    </div>
  );
};
